/**
 * BreadCrumb component
 * Fr : "Fil d'ariane"
 * used in IQB A&H, for a multi-page reservation process
 */
import { Component, Input , Output, EventEmitter } from '@angular/core';
import { IBreadcrumbItem } from '../../service/breadcrumb/IBreadcrumbItem';
import { faChevronRight, IconDefinition } from "@fortawesome/free-solid-svg-icons";


@Component({
    selector: 'breadcrumb',
    templateUrl: 'breadcrumb.html',
})
export class BreadcrumbComponent {

    @Input()
    public items: IBreadcrumbItem[];

    @Output()
    public readonly notify: EventEmitter<string> = new EventEmitter();

    public iconChevronRight: IconDefinition = faChevronRight;

    /**
     * notifyMe
     * event launcher
     */
    public notifyMe(index: number): void{
        this.notify.emit(this.items[index].action);
    }

}
